export default class Constants {
}
Constants.scalingFactor = 80;
Constants.polylineWidth = 8;
Constants.tierOffset = 100;
Constants.rendererBackgroundColour = 0xeeeeee;
Constants.horizontal = 1;
Constants.vertical = 0;
Constants.snapToEdgeDistance = 15;
